import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useBlogAuth } from './blog-auth-context';

/**
 * O portão das rotas logadas do portal (/conta, /cursos, /curso/:slug).
 * Enquanto a sessão resolve, não renderiza nada (a janela breve evita o flash
 * de redirect); sem sessão, manda ao login lembrando o destino — o login (nativo
 * ou a volta do Google) devolve a pessoa a ele.
 */
export function RequireAuth({ children }: { children: ReactNode }): JSX.Element | null {
  const { status, user } = useBlogAuth();
  const location = useLocation();

  if (status === 'loading') return null;

  if (status === 'unauthenticated' || !user) {
    return (
      <Navigate to="/login" replace state={{ from: `${location.pathname}${location.search}` }} />
    );
  }

  return <>{children}</>;
}
